// extracted by mini-css-extract-plugin
export default {"wrapper":"SelfVideo_wrapper__QpiD3","video":"SelfVideo_video__jjfjG"};